<template>
    <div class="entity-details-content">
        <form autocomplete="off" method="post" :data-vv-scope="vScope" @keyup.enter="() => {return false;}" @submit.prevent="() => {return false;}">
            <div class="row">
                <div class="col-12">
                    <EntityDetails
                        v-model="form"
                        :additional="additional"
                        :panelCfg="panelCfg"
                        :vScope="vScope"
                        :readonlyForm="readonlyForm"
                        :baseTranslateID="baseTranslateID"
                        :genders="genders"
                        :religions="religions"
                        :causes_death="causes_death"
                        addressTitle="last_known_address"
                    />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import FormMixin from "./mixins/FormMixin";

export default {
    mixins: [
        FormMixin,
    ],
    components: {
        EntityDetails: () => import(/* webpackChunkName: "cemeteries-entity-details" */ './elements/EntityDetails'),
    },
    props: {
        genders: {
            type: Array,
            default: () => {return [];},
        },
        religions: {
            type: Array,
            default: () => {return [];},
        },
        causes_death: {
            type: Array,
            default: () => {return [];},
        },
    },
    data() {
        let idPanel = 'entity';
        return {
            idPanel: idPanel,
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.entity-details-content {

}
</style>